/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1479
 */

"use strict"

function r(e) {
  if (Array.isArray(e)) {
    return e
  }
}
export { r as a }
export default r
